import './App.css';
import Data from './Data'

function App() {
  return (
    <div className="App">
      <Data />
    </div>
  );
}

export default App;
